import { BodyVariant } from "ui/Text/Body";
import { HeadingVariant } from "ui/Text/Heading";

const fontFamilies = {
  sourceSansPro: "Source Sans Pro",
} as const;

const fontWeights = {
  light: "300",
  regular: "400",
  semiBold: "600",
  bold: "700",
  back: "900",
} as const;

type FontFamily = typeof fontFamilies[keyof typeof fontFamilies];
type FontWeight = typeof fontWeights[keyof typeof fontWeights];

type TextConfiguration = {
  fontFamily: FontFamily;
  fontSize: number;
  fontWeight: FontWeight;
};

type Typography = {
  fontFamilies: typeof fontFamilies;
  fontWeights: typeof fontWeights;
  body: Record<BodyVariant, TextConfiguration>;
  heading: Record<HeadingVariant, TextConfiguration>;
};

export const typography: Typography = {
  fontFamilies,
  fontWeights,
  body: {
    body1: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 16,
      fontWeight: fontWeights.bold,
    },
    body2: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 18,
      fontWeight: fontWeights.light,
    },
    body3: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 14,
      fontWeight: fontWeights.bold,
    },
    body4: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 16,
      fontWeight: fontWeights.regular,
    },
    body5: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 14,
      fontWeight: fontWeights.semiBold,
    },
    body6: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 14,
      fontWeight: fontWeights.regular,
    },
    body7: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 14,
      fontWeight: fontWeights.light,
    },
    body8: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 12,
      fontWeight: fontWeights.regular,
    },
    body9: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 11,
      fontWeight: fontWeights.light,
    },
  },
  heading: {
    h1: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 50,
      fontWeight: fontWeights.bold,
    },
    h2: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 32,
      fontWeight: fontWeights.bold,
    },
    h3: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 25,
      fontWeight: fontWeights.bold,
    },
    h4: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 18,
      fontWeight: fontWeights.bold,
    },
    h5: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 18,
      fontWeight: fontWeights.regular,
    },
    h6: {
      fontFamily: fontFamilies.sourceSansPro,
      fontSize: 16,
      fontWeight: fontWeights.bold,
    },
  },
};
